import { render, staticRenderFns } from "./ShippingCompanyBlock.vue?vue&type=template&id=09264dc9&scoped=true"
import script from "./ShippingCompanyBlock.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyBlock.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyBlock.vue?vue&type=style&index=0&id=09264dc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09264dc9",
  null
  
)

export default component.exports